/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClickFinderDocumentList } from '../../models/click-finder-document-list';
import { ClickFinderDocumentSearchData } from '../../models/click-finder-document-search-data';

export interface VaultGetClickFinderDocumentList$Params {

/**
 * GUID of the vault
 */
  vaultId: string;
  
    /**
     * Search data
     */
    body: ClickFinderDocumentSearchData
}

export function vaultGetClickFinderDocumentList(http: HttpClient, rootUrl: string, params: VaultGetClickFinderDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<ClickFinderDocumentList>> {
  const rb = new RequestBuilder(rootUrl, vaultGetClickFinderDocumentList.PATH, 'post');
  if (params) {
    rb.path('vaultId', params.vaultId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClickFinderDocumentList>;
    })
  );
}

vaultGetClickFinderDocumentList.PATH = '/vault/{vaultId}/click-finder/document/list';
